import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LoadingMask } from '@jove-frontend/uikit';
import { useAuthStore } from '../store/AuthStore';
import { Routes } from './routes';

export const withOnboardingRequired = (
  WrappedComponent: React.ComponentType
) => {
  const ComponentWithOnboardingRequired = (props: Record<string, unknown>) => {
    const router = useRouter();
    const { isLoading } = useAuth0();
    const [{ user, isLoading: isStoreLoading, isUserOnboarded }] = useAuthStore(
      ({ state }) => [state]
    );
    const hasRedirectedRef = useRef(false);

    /**
     * effects
     */
    useEffect(() => {
      if (isLoading || isStoreLoading) return;

      if (user && !isUserOnboarded && !hasRedirectedRef.current) {
        hasRedirectedRef.current = true;
        router.push(Routes.onboarding(router.asPath));
      }
    }, [isLoading, isStoreLoading, user, isUserOnboarded]);

    if (isLoading || isStoreLoading) {
      return <LoadingMask />;
    }

    return <WrappedComponent {...props} />;
  };

  return ComponentWithOnboardingRequired;
};
